module.exports = __webpack_public_path__ + "faqs-ban-bg.cbbcfc19052677a4630a.webp";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/faqs-ban-bg.webp
// module id = ../../../../../src/assets/img/faqs-ban-bg.webp
// module chunks = styles